document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".drawer-menu")) return;
  initDrawerHeaderToggle();
  initAccordion();
});

function initAccordion() {
  const toggles = document.querySelectorAll(".js-accordion-subitem-menu");
  toggles.forEach((toggle) => {
    toggle.addEventListener("click", function (event) {
      event.preventDefault();
      const subCategories = toggle.nextElementSibling;
      const openIcon = toggle.querySelector(".js-subitem-icon_open");
      const closeIcon = toggle.querySelector(".js-subitem-icon_close");

      if (
        subCategories &&
        subCategories.classList.contains("container-subcategories")
      ) {
        const isOpen = subCategories.style.display === "flex";
        subCategories.style.display = isOpen ? "none" : "flex";
        openIcon.style.display = isOpen ? "none" : "inline-flex";
        closeIcon.style.display = isOpen ? "inline-flex" : "none";
      }
    });
  });
}

function initDrawerHeaderToggle() {
  const drawerHeader = document.querySelector(".drawer-menu__header");
  document.addEventListener("click", function (e) {
    const parentLink = e.target.closest('[data-item="parent"]');
    const backButton = e.target.closest('[data-item="back"]');

    if (drawerHeader) {
      if (parentLink) drawerHeader.classList.add("hidden-header");
      if (backButton) drawerHeader.classList.remove("hidden-header");
    }
  });
}
